import React, { useContext, useEffect } from "react";
import { FormContext } from "@/contexts/FormDataContext";
import { useTranslation } from "@/hooks/useTranslation";
import "./styles.scss";

const ProofOfTravel = ({ serviceName }: { serviceName: string }) => {
  const { t } = useTranslation();
  const {
    proofOfTravelValue,
    setProofOfTravelValue,
    proofOfTravelError,
    setProofOfTravelError,
    selectedMethod,
    proofOfTravelRef,
  } = useContext(FormContext)!;

  useEffect(() => {
    if (selectedMethod === serviceName) {
      setProofOfTravelValue("");
      setProofOfTravelError(false);
    }
  }, [selectedMethod, serviceName, setProofOfTravelValue, setProofOfTravelError]);

  const handleChange = (value: string) => {
    setProofOfTravelValue(value);
    setProofOfTravelError(value === "no");
  };

  return (
    <div
      className="proofOfTravel"
      ref={proofOfTravelRef}>
      <div className="proofOfTravel__content">
        <h4 className="proofOfTravel__label">{t("Requires proof of travel")}</h4>

        <label
          className={`proofOfTravel__option ${proofOfTravelValue === "yes" ? "selected" : ""}`}>
          <input
            type="radio"
            name={`proof-of-travel-${serviceName}`}
            value="yes"
            checked={proofOfTravelValue === "yes"}
            onChange={() => handleChange("yes")}
            data-qa={`proof-of-travel-${serviceName}-yes`}
          />
          <div className="proofOfTravel__options-radio-container">
            <div className="proofOfTravel__options-radio-circle"></div>
            <span>{t("Yes, I have it")}</span>
          </div>
        </label>

        <label className={`proofOfTravel__option ${proofOfTravelValue === "no" ? "selected" : ""}`}>
          <input
            type="radio"
            name={`proof-of-travel-${serviceName}`}
            value="no"
            checked={proofOfTravelValue === "no"}
            onChange={() => handleChange("no")}
            data-qa={`proof-of-travel-${serviceName}-no`}
          />
          <div className="proofOfTravel__options-radio-container">
            <div className="proofOfTravel__options-radio-circle"></div>
            <span>{t("No")}</span>
          </div>
        </label>
      </div>

      {proofOfTravelError && (
        <div className="proofOfTravel__error">
          {t("Please select Standard Service if you don't have immediate travel plans.")}
        </div>
      )}
    </div>
  );
};

export default ProofOfTravel;
